import React from "react";
import Navbar from "../Navbar";
interface Props {
  children: React.ReactNode;
  customNavbar?: React.ReactNode;
}
export default function PageLayout({ children, customNavbar }: Props) {
  return (
    <div className="flex-1 min-w-0 flex flex-col gap-4 lg:ml-[17rem]">
      {customNavbar ? customNavbar : <Navbar />}
      <div className="app-fade-up relative min-w-0">
        {children}
      </div>
    </div>
  );
}
